// extracted by mini-css-extract-plugin
export default {"root":"Input_root__ibAEf","icon":"Input_icon__B21U6","text":"Input_text__Sxckm","title":"Input_title__dJhft","input":"Input_input__Miuzo"};